import { useMutation } from '@tanstack/react-query';
import { UpdatePasswordDto, UserWalletManageService } from 'services/openapi';

type UpdatePasswordMutationVariables = {
  userId: string;
  requestBody: UpdatePasswordDto;
};

export const useUpdatePasswordMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, UpdatePasswordMutationVariables>({
      mutationFn: (variables: UpdatePasswordMutationVariables) => {
        return UserWalletManageService.userManageControllerUpdatePassword(
          variables.userId,
          variables.requestBody,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
